import request from '@/utils/request'

// 修改邮箱
export function updateEmail(data) {
  return request({
    url: '/front/profile/email',
    method: 'put',
    data
  })
}

// 修改密码
export function updatePassword(data) {
  return request({
    url: '/front/profile/password',
    method: 'put',
    data
  })
}

// 上传头像
export function updateAvatar(data) {
  return request({
    url: '/front/profile/avatar',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
